import PropTypes from 'prop-types'
import { Alert, AlertTitle, Portal, Snackbar } from '@mui/material'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'

/**
 * Said over the job detail when the read opened a job only because this machine can do it
 * (TECHNOLOGY_PLANNED, RN28): the plan has it somewhere else, and the operator should know before
 * starting it here.
 *
 * Outside JobDetailMos on purpose, which is consumed as is (R9), and above its modal like the Single
 * Job Mode notice. A Snackbar and not a dialog: it neither takes the focus nor blocks the detail, and
 * it stays until the operator dismisses it or closes the detail — no timer, since a warning that hides
 * while the operator is reading the detail would go unseen. At the bottom because, being permanent, at
 * the top it would cover the detail's own alerts and the Single Job Mode notice, which sit top-center.
 *
 * In a Portal because a Snackbar is not one: inside the widget card, whose backdrop-filter traps a fixed
 * child in its own stacking context, its z-index lost to the job detail's dialog (jupiter#3134).
 */
const QrNotPlannedHereNotice = ({ open = false, plannedAt = '', onClose = () => {} }) => {
  const { t_ } = useSmartTranslation()

  return (
    <Portal>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ zIndex: (theme) => theme.zIndex.modal + 2 }}
      >
        <Alert severity='warning' onClose={onClose} sx={{ boxShadow: 6 }}>
          <AlertTitle sx={{ mb: plannedAt === '' ? 0 : 0.25 }}>{t_('Not planned on this machine')}</AlertTitle>
          {plannedAt !== '' && t_('In the plan it is at {{machine}}', { machine: plannedAt })}
        </Alert>
      </Snackbar>
    </Portal>
  )
}

QrNotPlannedHereNotice.propTypes = {
  open: PropTypes.bool,
  /** The machine the plan has the job at; '' when Sun did not say, or said this very machine. */
  plannedAt: PropTypes.string,
  onClose: PropTypes.func
}

export default QrNotPlannedHereNotice
